import { ExportContext, ExportHooks } from '@access-erp/common';
import { JSX, PropsWithChildren, useMemo } from 'react';

import { useCreateExportJobMutation } from '../hooks/ExportJob/useCreateExportJob';
import { CreateExportJobMutationVariables } from '../hooks/ExportJob/exportJob.gql';
import { Forms } from '@/graphql/contracts/_generated_/contracts';

export const ExportProvider = ({ children }: PropsWithChildren): JSX.Element => {
  const [createExportJob] = useCreateExportJobMutation();

  const handleCreateExportJob = async (variables: CreateExportJobMutationVariables) => {
    const result = await createExportJob({ variables });
    return result?.data?.general?.exportJobs?.createExportJob;
  };

  const value: ExportHooks<Forms> = useMemo(
    () => ({ createExportJob: handleCreateExportJob } as any),
    [createExportJob],
  );

  return <ExportContext.Provider value={value as any}>{children}</ExportContext.Provider>;
};
